export const RESIZE_DIRECTION_ENUM = {
  START: 'start',
  END: 'end'
};
